"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const steps_1 = tslib_1.__importDefault(require("antd/es/steps"));
exports.Step = (props) => {
    return (React.createElement("div", { className: 'clp-steps' },
        React.createElement(steps_1.default.Step, Object.assign({}, props))));
};
//# sourceMappingURL=Step.js.map